import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const FSharpLanguageIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M144 384h650v136H294v442h463v135H294v567H144V384zm1517 446l-56 264h247l-24 93h-241l-78 349h-110l75-349h-220l-73 349h-110l74-349H914l18-93h233l53-264H975l18-93h244l74-353h111l-74 353h221l76-353h108l-74 353h231l-20 93h-229zm-109 0h-222l-58 264h223l57-264z" />
    </svg>
  ),
  displayName: 'FSharpLanguageIcon',
});

export default FSharpLanguageIcon;
